import { Typography, styled } from "@mui/material";

export const StyledTypography = styled(Typography)({
  fontWeight: "bold",
  marginBottom: "0.8rem",
});
